// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TX1-O","colBig":"styles_colBig__ypNHR","colSmall":"styles_colSmall__2psXy","shopifyNameWrapper":"styles_shopifyNameWrapper__1GAZN"};